import React from "react";
import InlineSVG from "react-inlinesvg";
import relinkRed from "../../../icon/relink-color.svg";
import FJLocalStore from "../../../store/FJLocalStore";
import styles from './FJLinkPrompt.module.less'

function FJLinkPrompt(props) {

  let {onClick} = props;
  return (
    <div className={styles.link_desc} onClick={onClick}>
      <InlineSVG src={relinkRed} element='div' />
      <p className={styles.word}>{FJLocalStore._('please-relink-missing-files')}</p>
    </div>
  )
}

export default FJLinkPrompt;